import { Vocabulary } from "./Vocabulary";
import { urlEnum } from "./urlEnum";

export interface WebsiteModel {
  name: string;
  code: string;
  url: string;
  disabled?: boolean;
}

export const WEBSITE_INTEGRATIONS: WebsiteModel[] = [
  {
    name: Vocabulary.autodelrulate,
    code: "autodelrulate",
    url: urlEnum.postOnSite,
    disabled: true,
  },
  {
    name: Vocabulary.autovit,
    code: "autovit",
    url: urlEnum.autovit,
  },
  {
    name: Vocabulary.bestauto,
    code: "bestauto",
    url: urlEnum.bestauto,
  },
  {
    name: Vocabulary.plusAuto,
    code: "plusauto",
    url: urlEnum.plusAuto,
  },
  // {
  //   name: Vocabulary.xauto,
  //   code: "xauto",
  //   url: urlEnum.xauto,
  // },
  // {
  //   name: Vocabulary.autovit + ` (${Vocabulary.secondaryAccount})`,
  //   code: "autovit_secondary",
  //   url: urlEnum.autovit + "?account=autovit_secondary",
  // },
];

/**
 * Check if a vehicle is synced on a specific website
 * @param vehicle - Vehicle object
 * @param websiteCode - Website code (prefix)
 * @returns true if synced, false otherwise
 */
export const isVehicleSyncedOnWebsite = (
  vehicle: any,
  websiteCode: string,
): boolean => {
  if (!vehicle) return false;

  // For autodelrulate, check if slug exists
  if (websiteCode === "autodelrulate") {
    return vehicle?.slug ? true : false;
  }

  // For other websites, check if advert_data field exists
  const advertField = `${websiteCode.toLowerCase()}_advert_data`;
  return vehicle?.[advertField] ? true : false;
};
